// extracted by mini-css-extract-plugin
export default {"viewer":"viewer3d_viewer__pDU5K","canvasContainer":"viewer3d_canvasContainer__3A24A","configurator":"viewer3d_configurator__r68WE","child":"viewer3d_child__E-tzd"};